import { useEffect, useState } from "react";

export const generalHighlightShift = (shiftNo: number, dayNo: number, action: "highlight" | "clear" | "clearAll") => {
	window.dispatchEvent(
		new CustomEvent<{
			shiftNo: number;
			dayNo: number;
			action: "highlight" | "clear" | "clearAll";
		}>("shiftHighlighted", { detail: { shiftNo, dayNo, action } }),
	);
};

export const useShiftHighlight = (shiftNo: number, dayNo: number) => {
	const [isShiftIdHighlighted, setIsShiftIdHighlighted] = useState(false);

	useEffect(() => {
		interface ShifteHighlightEvent extends CustomEvent {
			detail: {
				shiftNo: number;
				dayNo: number;
				action: "highlight" | "clear" | "clearAll";
			};
		}

		const handleHighlight = (e: ShifteHighlightEvent) => {
			if (e.detail.action === "highlight") {
				setIsShiftIdHighlighted(e.detail.shiftNo === shiftNo && e.detail.dayNo === dayNo);
			} else if (e.detail.action === "clear" && e.detail.shiftNo === shiftNo && e.detail.dayNo === dayNo) {
				setIsShiftIdHighlighted(false);
			} else if (e.detail.action === "clearAll") {
				setIsShiftIdHighlighted(false);
			}
		};

		window.addEventListener("shiftHighlighted", handleHighlight as EventListener);
		return () => window.removeEventListener("shiftHighlighted", handleHighlight as EventListener);
	}, [shiftNo, dayNo]);

	const highlightShift = () => {
		window.dispatchEvent(
			new CustomEvent<{ shiftNo: number; dayNo: number; action: string }>("shiftHighlighted", {
				detail: {
					shiftNo,
					dayNo,
					action: "highlight",
				},
			}),
		);
	};

	const clearShiftHighlight = () => {
		window.dispatchEvent(
			new CustomEvent<{ shiftNo: number; dayNo: number; action: string }>("shiftHighlighted", {
				detail: {
					shiftNo,
					dayNo,
					action: "clear",
				},
			}),
		);
	};

	return { isShiftIdHighlighted, highlightShift, clearShiftHighlight };
};
